import { IonLabel } from "@ionic/react";
import { forwardRef } from "react";
import { cn } from "@/lib/style/cva.config";

export type FormFieldLabelProps = {
  required?: boolean;
  disabled?: boolean;
};

export const FormFieldLabel = forwardRef<
  HTMLIonLabelElement,
  React.ComponentProps<typeof IonLabel> & FormFieldLabelProps
>(function FormFieldLabel({ required, disabled, ...props }, ref) {
  return (
    <IonLabel
      ref={ref}
      {...props}
      className={cn(
        "font-medium text-txt-primary",
        !disabled && required && "after:ms-0.5 after:text-red-500 after:content-['*']",
        props.className,
      )}
    />
  );
});
